import React from "react";

import {
  getInitials,
  isAccountTeamVendor,
  resolveExecSponsorBadgeType,
  resolveVendorDisplayName,
  resolveVendorJobTitle,
  resolveVendorRoleTag,
} from "./relationshipUtils";
import { getVendorProfileAvatarBg } from "../../../Utils/Helper/profileAvatarUi";

export function VendorSponsorBadge({ sponsorType }) {
  if (sponsorType === "primary") {
    return (
      <span className="sponsor-badge primary" title="Primary sponsor">
        P
      </span>
    );
  }
  if (sponsorType === "secondary") {
    return (
      <span className="sponsor-badge secondary" title="Secondary sponsor">
        S
      </span>
    );
  }
  return null;
}

/** Primary / Secondary sponsor key beside Exec Team section headers. */
export function ExecTeamPsLegend() {
  return (
    <span className="ps-legend" aria-label="Sponsor legend">
      <span className="ps-key">
        <VendorSponsorBadge sponsorType="primary" />
        Primary
      </span>
      <span className="ps-key">
        <VendorSponsorBadge sponsorType="secondary" />
        Secondary
      </span>
    </span>
  );
}

/** Vendor row column width when P/S legend is shown (buddy tables). */
export const VENDOR_STAKEHOLDER_COL_WIDTH = 240;

/** Relationship matrix vendor column — wider so Exec Team + P/S legend stay on one line. */
export const MATRIX_VENDOR_STAKEHOLDER_COL_WIDTH = 300;

/** Exec = orange; account team = blue. Filling only — size/class per layout variant. */
function VendorStakeholderAvatar({ isTeam, displayName, layout }) {
  const initials = getInitials(displayName);
  const fill = getVendorProfileAvatarBg(isTeam);

  if (layout === "buddy") {
    return (
      <div
        className="at-avatar"
        style={{ background: fill, width: 24, height: 24, fontSize: 9 }}
      >
        {initials}
      </div>
    );
  }

  return (
    <div
      className={isTeam ? "at-avatar" : "v-avatar"}
      style={{ background: fill }}
    >
      {initials}
    </div>
  );
}

/**
 * Shared vendor row label for stakeholder mapping, relationship matrix, and coverage modal.
 * @param {'buddy'|'matrix'} variant — buddy-row-hdr (Account Details / coverage) vs vrow-hdr (matrix)
 */
export function VendorRowLabel({ vendor, variant = "buddy" }) {
  const isTeam = isAccountTeamVendor(vendor);
  const displayName = resolveVendorDisplayName(vendor);
  const jobTitle = resolveVendorJobTitle(vendor);
  const roleTag = resolveVendorRoleTag(vendor);
  const sponsorBadge = !isTeam ? resolveExecSponsorBadgeType(vendor) : null;
  const layout = variant === "matrix" ? "matrix" : "buddy";

  const nameRow = (
    <>
      {displayName}
      {!isTeam && sponsorBadge ? (
        <VendorSponsorBadge sponsorType={sponsorBadge} />
      ) : null}
      {isTeam && roleTag ? <span className="role-tag">{roleTag}</span> : null}
    </>
  );

  if (variant === "matrix") {
    return (
      <div className="vrow-hdr">
        <VendorStakeholderAvatar
          isTeam={isTeam}
          displayName={displayName}
          layout={layout}
        />
        <div className="v-info">
          <div className="v-name">{nameRow}</div>
          {jobTitle ? <div className="v-title">{jobTitle}</div> : null}
        </div>
      </div>
    );
  }

  return (
    <div className="buddy-row-hdr">
      <VendorStakeholderAvatar
        isTeam={isTeam}
        displayName={displayName}
        layout={layout}
      />
      <div className="min-w-0">
        <div className="buddy-row-name">{nameRow}</div>
        {jobTitle ? <div className="buddy-row-sub">{jobTitle}</div> : null}
      </div>
    </div>
  );
}
